import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {Http, URLSearchParams} from '@angular/http';
// Notice it is imported from @angular/common/http instead of @angular/http
import {HttpClient} from '@angular/common/http';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class CartService extends OauthService {

  public loader = new Subject<boolean>();
  public cartCache = new Subject<any>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public httpClient: HttpClient,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
    this.loader.next(true); // init custom loader
  }

  initCart() {
    this.getCart()
      .subscribe(
        data => {
          let total = 0;

          if (data && data.lignes) {
            for (const line of data.lignes) {
              total += line.quantite;
            }
          }

          this.tools.localStorageService.setTotalCart(total);
          this.cartCache.next(data);
          this.checkIfReducce(data);
        },
        error => console.error(error)
      );
  }

  getCart() {
    const url = this.Routing.generate('api_get_panier', {'_format': 'json'}, true);
    const params = new URLSearchParams();

    return this.http
      .get(url, {search: params, headers: this.updateHeaders('beneficiaire')})
      .map(response => {
        this.loader.next(false); // disable custom loader
        return response.json().data;
      });
  }

  addCart(cart) {
    const url = this.Routing.generate('api_post_panier_add', {'_format': 'json'}, true);

    return this.httpClient

      .post(url, JSON.stringify(cart), {headers: this.updateHttpHeaders('beneficiaire'), observe: 'response'})
      .map(response => response);
  }

  removeLineCart(idLineCart) {
    const url = this.Routing.generate('api_delete_panier', {'_format': 'json', 'ligneCommande': idLineCart}, true);

    return this.http
      // .delete(`${url}/${idLineCart}`, {headers: this.updateHeaders('beneficiaire')})
      .delete(`${url}`, {headers: this.updateHeaders('beneficiaire')})
      .map(response => {
        return response;
      });
  }

  removeCart() {
    const url = this.Routing.generate('api_get_panier_vider', {'_format': 'json'}, true);

    return this.http
      .get(url, {headers: this.updateHeaders('beneficiaire')})
      .map(response => {
        return response;
      });
  }

  createCmd(cart) {
    const url = this.Routing.generate('api_post_checkout_creation', {'_format': 'json', 'cart': cart}, true);

    return this.http
      .post(`${url}`, '', {headers: this.updateHeaders('beneficiaire')})
      .map(response => response.json());
  }

  checkoutCart(cart) {
    const url = this.Routing.generate('api_post_checkout_validation', {'_format': 'json', 'cart': cart}, true);

    return this.http
      .post(`${url}`, '', {headers: this.updateHeaders('beneficiaire')})
      .map(response => response.json());
  }

  invoiceCart(cart) {
    const url = this.Routing.generate('api_post_checkout_validation', {'_format': 'json', 'cart': cart}, true);

    return this.http
      .post(`${url}`, JSON.stringify({facturer: 1}), {headers: this.updateHeaders('beneficiaire')})
      .map(response => response.json());
  }

  checkIfReducce(data: any) {
    let result = false;
    console.log("checkIfReducce");
    console.log(data);
    if(data && data.lignes.length > 0) {
      const f = data.lignes.find((l) => (l.article.type === 'REDUCCE' || (l.article.article && l.article.article.articlesType === 'ETICKET')));
      result =  !(f == null || f == undefined);
    }

    if (result) {
      this.tools.localStorageService.setSourceDeDonnees('REDUCCE');
    } else {
      this.tools.localStorageService.setSourceDeDonnees('AFPA');
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/cart.service.ts